import { UPDATE_ADDRESS_DEFAULT_SUCCESS, UPDATE_ADDRESS_DEFAULT_REQUEST, UPDATE_ADDRESS_DEFAULT_FAILURE, UPDATE_ADDRESS_DEFAULT_RESET } from "@/redux/actions";
const initialState = {
    data: null,
    loading: false,
    error: null,
};
const updateAddressDefaultReducer = (state = initialState, action) => {
    switch (action.type) {
        case UPDATE_ADDRESS_DEFAULT_SUCCESS:
            return Object.assign(Object.assign({}, state), { loading: false, error: null, data: action.payload });
        case UPDATE_ADDRESS_DEFAULT_REQUEST:
            return Object.assign({}, state);
        case UPDATE_ADDRESS_DEFAULT_FAILURE:
            return Object.assign(Object.assign({}, state), { loading: false, error: action.payload });
        case UPDATE_ADDRESS_DEFAULT_RESET:
            return Object.assign(Object.assign({}, state), { loading: false, data: null, error: null });
        default:
            return state;
    }
};
export default updateAddressDefaultReducer;
